import { get, set } from 'lib/storage/isomorphicLocalStorage'

export const AGENT_HUB_BOOKING_ONBOARDING_STORAGE_KEY = 'leah.bookingPlatformOnboarding.v1'

export type AgentHubBookingOnboardingStatus = 'completed' | 'dismissed'

type AgentHubBookingOnboardingStatusListener = () => void

const statusListeners = new Set<AgentHubBookingOnboardingStatusListener>()

function notifyAgentHubBookingOnboardingStatusChanged(): void {
  statusListeners.forEach(listener => listener())
}

export function subscribeAgentHubBookingOnboardingStatus(
  listener: AgentHubBookingOnboardingStatusListener,
): () => void {
  statusListeners.add(listener)

  return () => {
    statusListeners.delete(listener)
  }
}

type AgentHubBookingOnboardingStore = Record<string, {
  status: AgentHubBookingOnboardingStatus
  updatedAt: string
}>

function readStore(): AgentHubBookingOnboardingStore {
  const stored = get(AGENT_HUB_BOOKING_ONBOARDING_STORAGE_KEY)
  if (!stored || typeof stored !== 'object') {
    return {}
  }

  return stored as AgentHubBookingOnboardingStore
}

export function getAgentHubBookingOnboardingStatus(
  memberId: string,
): AgentHubBookingOnboardingStatus | undefined {
  return readStore()[memberId]?.status
}

export function setAgentHubBookingOnboardingStatus(
  memberId: string,
  status: AgentHubBookingOnboardingStatus,
): void {
  const nextStore = {
    ...readStore(),
    [memberId]: {
      status,
      updatedAt: new Date().toISOString(),
    },
  }

  set(AGENT_HUB_BOOKING_ONBOARDING_STORAGE_KEY, nextStore)
  notifyAgentHubBookingOnboardingStatusChanged()
}
